import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ModalService } from 'app/common/services/modal.service';
import { iconAdd, iconArrowBack, iconDownload, iconPublish, iconSave, iconStore, iconTrash } from 'app/common/utils/icons.utils';
import { IngrediantService } from 'app/services/ingrediant.service';
import { ReceipeDTO, Recipe } from 'app/models/recipe.model';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'app/common/services/toasts.service';

import { Gtag } from 'angular-gtag';
import { AuthService } from 'app/auth-core/auth.service';
import { BaseComponent } from 'app/common/components/base.component';
import { RecipeService } from 'app/services/recipe.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalOptions } from 'app/common/models/models';
import { PopupInfoComponent } from '../popup-info/popup-info.component';
import { ProfileService } from 'app/services/profile.service';

@Component({
	selector: 'receipt-creation',
	templateUrl: './receipt-creation.component.html',
	styleUrls: ['receipt-creation.component.scss']
})
export class RecipePage extends BaseComponent implements OnInit, AfterViewInit{
	recipe: Recipe;
	showGoBack;
	
	// public form: FormGroup = null;
	pageLoaded = false;
	iconCancel = iconTrash;
	iconAdd = iconAdd;
	iconSave = iconStore;
	iconDownload = iconDownload;
	iconUpload = iconPublish;
	iconArrowBack = iconArrowBack;
	constructor(
		protected _translateService: TranslateService,
		protected _toastService: ToastService,
		protected gtag: Gtag,
		protected authService: AuthService,
		protected _recipeService: RecipeService,
		protected _activatedRoute: ActivatedRoute,
		protected _modalService: ModalService,
		protected _userProfileService: ProfileService,
		protected _router: Router
	) {
		super();
	}
	
	saveEnabled = () => {
		return true;
	}
	goBack = () => {
		history.back();
	}
	
	newRecipe = () => {
		this.recipe = new Recipe();
	}

	isAutenticated = false;
	ngOnInit() {
		console.log("SUB CLASS");
		
		this.on(
			this.authService.isAuthenticated$.subscribe((isAutenticated) => {
				this.isAutenticated = isAutenticated;
			})
		)
		this.pageLoaded = true;

	}
	openLearnMore = () => {
		let modalOption: ModalOptions<any> = {
			size: 'xl',
			callback: (res) => {}
		}
		let data = {
			sectionId: "RECIPE"
		}
		this._modalService.show(PopupInfoComponent, data, modalOption);
	}
	ngAfterViewInit(): void {
		this.gtag.event('receipt-page', {
			event_category: "Page view",
			'app_name': "switch-food-explorer",
			'screen_name': 'receipt-page'
		});
	}
	
	updateRecipe = (recipe) => {
		console.log("recipe updates");
		
		this.recipe = recipe;
	}

	get canSave() {
		return this.recipe && this.recipe.recipeName?.length > 0 && this.recipe.servings > 0 && this.recipe.ingrediants?.length > 0;
	}
	get recipeName() {
		if (this.recipe && this.recipe.recipeName) return this.recipe.recipeName;
		return false;
	}
	downloadMessage = "";
	
	

	@ViewChild('fileInput') fileInput: ElementRef;

	public loadReceipt = () => {
		if (this.isAutenticated && this.canSave && this.saveEnabled()) {
			this.fileInput.nativeElement.click();
		}
	}
	public fileChanged = (e) => {
		let file = e.target.files[0];
		let fileReader = new FileReader();
		fileReader.onload = (e) => {
			try {
				let dto: ReceipeDTO = JSON.parse(""+fileReader.result);
				this.recipe = this._recipeService.fromDTOToRecipe(dto);
				this._toastService.showSuccess(this._translateService.instant("recipePage.loadReciptSuccess"));
				this.fileInput.nativeElement.value = null;
			} catch (error) {
				this._toastService.showDanger(this._translateService.instant("recipePage.loadReciptError"));
			}
			
		}
		if (file)
			fileReader.readAsText(file);
	}

	public storeRecipe = () => {
		if (this.isAutenticated && this.canSave && this.saveEnabled()) {
			this._recipeService.saveOrUpdate(this.recipe).subscribe((result) => {
				this._toastService.showSuccess(this._translateService.instant("recipePage.receipeSavedMessage"));
			})
			
		}
		
	}

	public saveReceipt = () => {
		let dto: ReceipeDTO = this._recipeService.fromRecipeToDTO(this.recipe);
		dto.id = null;
		const blob = new Blob([JSON.stringify(dto)], { type: 'text/json' });
	
		// Create a link to the blob
		const link = document.createElement('a');
		link.href = window.URL.createObjectURL(blob);
		link.download = (dto.recipeName && dto.recipeName.trim())? dto.recipeName.trim() + ".switch": 'recipt.switch';
		link.click();
		this._toastService.showSuccess(this._translateService.instant("recipePage.downloadReceiptMessage"));
	}
}